import redirectResolverQuery from '~layers/app/graphql/routes/redirectResolver.gql'

export function useCustomRouterRedirect() {
  const { client } = useApolloClient('default')

  const fetchRedirect = async (path: string) => {
    const result = await client.query<any>({
      query: redirectResolverQuery,
      variables: { url: path },
    })
    return {
      code: result?.data?.redirectResolver?.redirectCode || 301,
      url: result?.data?.redirectResolver?.relative_url || result?.data?.esUrlByAlternativeUrl?.url,
    }
  }

  return {
    fetchRedirect,
  }
}
